function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Layout, Menu, message, Drawer } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import { ClockHistory, Power } from 'react-bootstrap-icons';
import AddPumpReport from '../components/forms/AddPumpReport';
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer;
import Common from '../components/includes/Common';
import { useNavigate } from 'react-router-dom';
import PumpReportsHistory from '../components/PumpReportsHistory';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HomeAgent = function HomeAgent() {
  var _useState = useState('hist'),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHistoryVisible = _useState4[0],
    setIsHistoryVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataChanged = _useState6[0],
    setIsDataChanged = _useState6[1];
  var navigate = useNavigate();
  var onMenuClick = function onMenuClick(e) {
    setCurrent(e.key);
    switch (e.key) {
      case 'quit':
        axios.post(Common.baseApiUrl + 'logout').then(function (response) {
          if (response.data.status == 200) {
            localStorage.clear();
            navigate('/');
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        });
        break;
      case 'history':
        setIsHistoryVisible(true);
        break;
    }
  };
  return /*#__PURE__*/_jsxs(Layout, {
    className: "layout",
    children: [/*#__PURE__*/_jsxs(Header, {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '130px'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/ss.png",
          style: {
            width: "100%"
          }
        })
      }), /*#__PURE__*/_jsx(Menu, {
        theme: "light",
        mode: "horizontal",
        defaultSelectedKeys: ['hist'],
        onClick: onMenuClick,
        items: [{
          label: /*#__PURE__*/_jsx("b", {
            children: "HISTORIQUE"
          }),
          key: 'history',
          icon: /*#__PURE__*/_jsx(ClockHistory, {})
        }, {
          label: /*#__PURE__*/_jsx("b", {
            style: {
              color: '#EC5E5E'
            },
            children: "QUITTER"
          }),
          key: 'quit',
          icon: /*#__PURE__*/_jsx(Power, {})
        }]
      })]
    }), /*#__PURE__*/_jsx(Content, {
      style: {
        padding: '25px 50px',
        background: '#F5F5F5'
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "site-layout-content",
        style: {
          background: '#F5F5F5'
        },
        children: [/*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              lg: 5,
              md: 5,
              sm: 7,
              children: /*#__PURE__*/_jsx(AddPumpReport, {
                handler: function handler() {
                  setIsDataChanged(true);
                }
              })
            })
          })
        }), /*#__PURE__*/_jsx(Drawer, {
          title: /*#__PURE__*/_jsx("b", {
            children: "HISTORIQUE DES RAPORTS"
          }),
          width: "90%",
          open: isHistoryVisible,
          onClose: function onClose() {
            setIsHistoryVisible(false);
          },
          destroyOnClose: true,
          children: /*#__PURE__*/_jsx(PumpReportsHistory, {})
        })]
      })
    }), /*#__PURE__*/_jsx(Footer, {
      style: {
        textAlign: 'center'
      },
      children: "Guisoft Lab \xA92023, tous droits r\xE9serv\xE9s"
    })]
  });
};
export default HomeAgent;